import React, { Component } from 'react';
import * as d3 from 'd3';
import "./dialogue.css";

/* Thanks to: https://codepen.io/andymerskin/pen/NWqQydM */

class Dialogue extends Component {
  constructor(props){
      super(props);
   }
  render() {
    let classlist;

    classlist = `dialogue ${this.props.classList?this.props.classList:''} ${(this.props.type === 'regular')?' regular':''}`


    return (
      <div className={classlist}>
          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="0">
           <defs>
             <filter id="fancy-goo">
               <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
               <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9" result="goo" />
               <feComposite in="SourceGraphic" in2="goo" operator="atop" />
             </filter>
           </defs>
         </svg>
         <div className={`dialogue-blobs`}>

             {(this.props.type === 'blob')&&(
                  <React.Fragment>
                      <div className="dialogue-regular">
                        <div className="dialogue-text">
                          {this.props.children}
                        </div>
                      </div>
                   </React.Fragment>)}
             {(this.props.type === 'regular')&&(
               <React.Fragment>
                      <div className="dialogue-regular">
                        <div className="dialogue-text">
                          {this.props.children}
                        </div>
                      </div>
                    </React.Fragment>)}

         </div>
         <div className="dialogue-character-wrap">
           <div className="dialogue-character"><span>{this.props.title}</span></div>
         </div>
      </div>

    )
  }
}

export default Dialogue;
